import { useMemo } from "react";
import { useApiClient } from "../../../hooks/useApiClient";
import { type ISelectObject } from "../../../types/select";
import useSWRImmutable from "swr/immutable";
import { type ICommercialReceptionReasonResponse } from "../types";

interface IUseCommercialReceptionReasonReturnType {
  receptionReasonOptions: ISelectObject[];
  isLoading: boolean;
  isError: boolean;
}

/**
 * 商業登記 登記の種類（reception-reason）を取得するカスタムフック
 */
export const useCommercialReceptionReason =
  (): IUseCommercialReceptionReasonReturnType => {
    const { apiClient } = useApiClient();

    const fetcher = async (
      url: string
    ): Promise<ICommercialReceptionReasonResponse> => {
      const { data } = await apiClient.get<ICommercialReceptionReasonResponse>(
        url
      );
      return data;
    };

    const toSelectObjectList = (
      data: ICommercialReceptionReasonResponse | undefined
    ): ISelectObject[] => {
      if (data === undefined) return [];

      return data.list.map((item) => ({
        value: item.id.toString(),
        label: item.name,
      }));
    };

    const { data, error, isLoading } = useSWRImmutable<
      ICommercialReceptionReasonResponse,
      Error
    >("option/commercial/reception-reason", fetcher);

    const receptionReasonOptions = useMemo(
      () => toSelectObjectList(data),
      [data]
    );

    return {
      receptionReasonOptions,
      isLoading,
      isError: Boolean(error),
    };
  };
